import { CheckCircle, XCircle } from "@phosphor-icons/react";
import React from "react";
import { StyleSheet, View } from "react-native";

import CustomText from "../../../../components/common/general/CustomText/CustomText";
import { CourseInsightsStudentQuestionResult } from "../../../../graphql/generated/graphql";
import { colors, spacing } from "../../../../styles/design-system";

interface QuestionResultRowProps {
  result: CourseInsightsStudentQuestionResult;
}

const QuestionResultRow: React.FC<QuestionResultRowProps> = ({ result }) => {
  const isCorrect = result.isCorrect;
  const isPlaceholder = isCorrect === null || isCorrect === undefined;

  return (
    <View style={styles.container}>
      <View style={styles.headerRow}>
        {!isPlaceholder && (
          <View style={styles.iconContainer}>
            {isCorrect ? (
              <CheckCircle size={18} color={colors.success[700]} weight="regular" />
            ) : (
              <XCircle size={18} color={colors.error[700]} weight="regular" />
            )}
          </View>
        )}
        <CustomText text={result.questionText} size="s" useTranslationText={false} style={styles.questionText} />
      </View>

      {!isPlaceholder && (
        <View style={styles.answersContainer}>
          {!isCorrect && result.studentAnswer ? (
            <CustomText
              text={`Student: ${result.studentAnswer}`}
              size="xs"
              useTranslationText={false}
              style={styles.incorrectText}
            />
          ) : null}

          {result.correctAnswer ? (
            <CustomText
              text={isCorrect ? result.correctAnswer : `Correct: ${result.correctAnswer}`}
              size="xs"
              useTranslationText={false}
              style={styles.correctText}
            />
          ) : null}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: colors.grey[200],
    borderRadius: 8,
    backgroundColor: colors.white,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    gap: spacing.xs,
  },
  headerRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: spacing.xs,
  },
  iconContainer: {
    marginTop: 2,
  },
  questionText: {
    color: colors.grey[900],
    flex: 1,
  },
  answersContainer: {
    paddingLeft: 22,
    gap: 4,
  },
  incorrectText: {
    color: colors.error[700],
  },
  correctText: {
    color: colors.success[700],
  },
});

export default QuestionResultRow;
